import React from "react";
import { t } from "i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDownLeft, faArrowUpLeft } from "@fortawesome/pro-regular-svg-icons";

import { Badge, TBadgeType } from "components/badge/Badge";

type TransactionKindConfig = {
  labelKey: string;
  type: TBadgeType;
  icon: typeof faArrowUpLeft;
};

const TRANSACTION_KIND_CONFIG: Record<string, TransactionKindConfig> = {
  credit_adjustment: {
    labelKey: "Credit adjustment",
    type: "success",
    icon: faArrowUpLeft,
  },
  debit_adjustment: {
    labelKey: "Debit adjustment",
    type: "error",
    icon: faArrowDownLeft,
  },
  credit: {
    labelKey: "Credit",
    type: "success",
    icon: faArrowUpLeft,
  },
  debit: {
    labelKey: "Debit",
    type: "error",
    icon: faArrowDownLeft,
  },
  credit_transfer: {
    labelKey: "Credit",
    type: "success",
    icon: faArrowUpLeft,
  },
  debit_transfer: {
    labelKey: "Debit",
    type: "error",
    icon: faArrowDownLeft,
  },
  debit_refund: {
    labelKey: "Credit",
    type: "success",
    icon: faArrowUpLeft,
  },
  credit_refund: {
    labelKey: "Debit",
    type: "error",
    icon: faArrowDownLeft,
  },
};

export function getCreditTransactionKindBadge(kind: string) {
  const config = TRANSACTION_KIND_CONFIG[kind];

  if (!config) {
    return <span>-</span>;
  }

  return (
    <Badge type={config.type} size="small" iconLeft={<FontAwesomeIcon icon={config.icon} />}>
      {t(config.labelKey)}
    </Badge>
  );
}

export const NOTE_DISPLAY_MAX_LENGTH = 40;

export function getCreditTransactionNoteDisplay(note?: string | null) {
  return note?.trim() ? note.trim() : null;
}

export function truncateCreditTransactionNote(
  note: string,
  maxLength: number = NOTE_DISPLAY_MAX_LENGTH,
): string {
  const trimmed = note.trim();

  if (trimmed.length <= maxLength) {
    return trimmed;
  }

  return `${trimmed.slice(0, maxLength).trimEnd()}...`;
}
